export const toBoolean = (value: string) => value === 'true'
